module.exports = __webpack_public_path__ + "img/candy-cane.5e307ab6.png";